import './flash_message_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  gotIt () {
    this.element.remove()
  }
}
